module.exports = __webpack_public_path__ + "static/media/horizontal-logo-te.4e8434da.png";